export default "__VITE_PUBLIC_ASSET__51a0df2e__"